export function jqSearchBox() {

    /*----------------------------------
    絞り込み関連js start
    ----------------------------------*/


    var searchBox = '.searchBox'; // 絞り込む項目を選択するエリア
    var listItem = '.searchItem';   // 絞り込み対象のアイテム
    var hideClass = 'is-hide';     // 絞り込み対象外の場合に付与されるclass名
    //var searchBtn = '.searchBtn'; // 検索ボタン

    //検索（絞り込み）トリガー
    $(function() {
        // チェック（絞り込み）項目を変更した時
        $(document).on('change', searchBox + ' input', function() {
            search_filter();
        });

        //検索ボタンをクリックした時
        // $(searchBtn).on('click', function() {
        //     search_filter();
        // });
    });

    /**
     * リストの絞り込みを行う
     */
    function search_filter() {
    // 非表示状態を解除
    $(listItem).removeClass(hideClass);
    var hideCount = 0;
    for (var i = 0; i < $(searchBox).length; i++) {
        var name = $(searchBox).eq(i).find('input').attr('name');
        // 選択されている項目を取得
        var searchData = get_selected_input_items(name);
        // 選択されている項目がない、またはALLを選択している場合は飛ばす
        if(searchData.length === 0 || searchData[0] === '') {
        continue;
        }
        // リスト内の各アイテムをチェック
        for (var j = 0; j < $(listItem).length; j++) {
        // アイテムに設定している項目を取得
        var itemData = get_setting_values_in_item($(listItem).eq(j), name);
        // 絞り込み対象かどうかを調べる
        var check = array_match_check(itemData, searchData);
        if(!check) {
            $(listItem).eq(j).addClass(hideClass);
            hideCount++;
        }
        }
    }
    if ($(".p-interviewIv_listItem").length === $(".p-interviewIv_listItem.is-hide").length) {
        $('.no-result-message').text('該当するインタビューがありませんでした。');
    } else {
        $('.no-result-message').text('');
    }
    }


    /**
     * inputで選択されている値の一覧を取得する
     * @param  {String} name 対象にするinputのname属性の値
     * @return {Array}       選択されているinputのvalue属性の値
     */
    function get_selected_input_items(name) {
    var searchData = [];
    $('[name=' + name + ']:checked').each(function() {
        searchData.push($(this).val());
    });
    return searchData;
    }

    /**
     * リスト内のアイテムに設定している値の一覧を取得する
     * @param  {Object} target 対象にするアイテムのjQueryオブジェクト
     * @param  {String} data   対象にするアイテムのdata属性の名前
     * @return {Array}         対象にするアイテムのdata属性の値
     */
    function get_setting_values_in_item(target, data) {
    var itemData = target.data(data);
    if(!Array.isArray(itemData)) {
        itemData = [itemData];
    }
    return itemData;
    }

    /**
     * 2つの配列内で一致する文字列があるかどうかを調べる
     * @param  {Array} arr1 調べる配列1
     * @param  {Array} arr2 調べる配列2
     * @return {Boolean}    一致する値があるかどうか
     */
    function array_match_check(arr1, arr2) {
    // 絞り込み対象かどうかを調べる
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
        if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
        }
    }
    return arrCheck;
    }

    // エリア検索 チェックボックス制御
    $(function(){
    $('#checkAll_position').prop('checked', true);
    $('#search_position .search_item_each input[type="checkbox"]').change(function(){
        var cnt1 = $('#search_position .search_item_each input[type="checkbox"]:checked').length;
            if(cnt1 == 0) {
            $('#checkAll_position').prop('checked',true);
            } else {
            $('#checkAll_position').prop('checked',false);
            }
        });
    $('#checkAll_position').change(function() {
        if ($('#checkAll_position').prop('checked')) {
        $('#search_position .search_item_each input[type="checkbox"]').prop('checked', false);
        } else {
        $('#search_position .search_item_All input[type="checkbox"]').prop('checked', true);
        }
    });
    });
    // 機能検索 チェックボックス制御
    $(function(){
    $('#checkAll_tag').prop('checked', true);
    $('#search_tag .search_item_each input[type="checkbox"]').change(function(){
        var cnt1 = $('#search_tag .search_item_each input[type="checkbox"]:checked').length;
            if(cnt1 == 0) {
            $('#checkAll_tag').prop('checked',true);
            } else {
            $('#checkAll_tag').prop('checked',false);
            }
        });
    $('#checkAll_tag').change(function() {
        if ($('#checkAll_tag').prop('checked')) {
        $('#search_tag .search_item_each input[type="checkbox"]').prop('checked', false);
        } else {
        $('#search_tag .search_item_All input[type="checkbox"]').prop('checked', true);
        }
    });
    });

    // 絞り込みをクリア
    $(function(){
        $('.search_clear').on('click', function() {
            $('.search_item_each').find('input[type="checkbox"]').prop('checked', false);
            $(listItem).removeClass(hideClass);
        });
    });




    /*----------------------------------
    絞り込み関連js end
    ----------------------------------*/

    // アイテムのdata属性から値を取得して、アイテム内に表示する
    $(function () {
        $(".searchItem").each(function () {
            const positionRaw = $(this).attr("data-position");
            const tagRaw = $(this).attr("data-tag");

            const positionArr = positionRaw ? JSON.parse(positionRaw) : [];
            const tagArr = tagRaw ? JSON.parse(tagRaw) : [];

            const list = positionArr.concat(tagArr);

            const html = list.map(function (value) {
            return '<li>' + value + '</li>';
            }).join("");

            $(this).find(".cat").html(html);
        });
    });

}
